import { useEffect, useState } from 'react';

import './index.scss';

const STORAGE_KEY = 'donationBannerDismissedUntil';

const DonationBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const dismissedUntil = localStorage.getItem(STORAGE_KEY);
    const now = new Date();

    if (!dismissedUntil || new Date(dismissedUntil) < now) {
      setVisible(true);
    }
  }, []);

  const handleClose = () => {
    // Set next show date to 24 hours from now
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    localStorage.setItem(STORAGE_KEY, tomorrow.toISOString());
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="banner">
      <span onClick={handleClose} className="close-btn">
        ✕
      </span>
      <p>
        分享一篇面经或职场心得，或许就能改变一个人的路；帮他人，也是在成就曾经的自己！
      </p>
    </div>
  );
};

export default DonationBanner;
